import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	information: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.empty-state.information',
		defaultMessage: 'Plan and prioritize large chunks of work.',
		description: 'A message shown in the epic panel when there are no epic issues in the project.',
	},
	suggestion: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.empty-state.suggestion',
		defaultMessage:
			'Create your first {epicIssueTypeName} to start capturing and breaking down work for your team.',
		description: 'A message shown in the epic panel when there are no epic issues in the project.',
	},
	suggestionIssueTermRefresh: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.empty-state.suggestion-issue-term-refresh',
		defaultMessage:
			'Create your first {epicIssueTypeName} to start capturing and breaking down work for your team.',
		description: 'A message shown in the epic panel when there are no epic issues in the project.',
	},
});
